export const presentationTypeRoute = {
  PRESENTATION_TYPE_LIST: '/presentationType/list',
  PRESENTATION_TYPE_DETAIL: '/presentationType/detail/:recordId',
};
